import React from 'react';

const SearchOptions = ({ activeTab, setActiveTab }) => {
    const tabs = [
        { id: 'general', name: 'بحث عام', icon: '🔍' },
        // { id: 'categories', name: 'تصفح الفئات', icon: '📂' },
        { id: 'specs', name: 'مواصفات السيارة', icon: '🚗' },
    ];

    return (
        <div className="bg-white rounded-2xl shadow-xl p-2 mb-6">
            <div className="flex flex-col md:flex-row gap-l-5  gap-x-5">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`flex items-center justify-center py-4 px-6 rounded-xl mb-2 md:mb-0 transition-all duration-300 ${activeTab === tab.id
                            ? 'bg-gradient-to-r from-green-600 to-green-700 text-white shadow-lg transform -translate-y-1'
                            : 'text-gray-700 hover:bg-gray-50 hover:text-green-600 bg-white shadow-md'}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <span className={`text-2xl ${activeTab === tab.id ? 'text-white ' : ''} mr-2 `}>{tab.icon}</span>
                        <span className={`ont-semibold text-3xl ${activeTab === tab.id ? 'text-white ' : ''}  `}>{tab.name}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SearchOptions;